import React, {useEffect, useState} from "react";

import {viewAllChangeIdeaPackages, viewChangePackage} from "../../../services/ChangePackageService";
import {SelectableTable} from "../../common/table/SelectableTable";

export const ChangePackageSearch = ({context, setContext, navigateTo, showToaster, setSpinnerText}) => {

    const [searchResults, setSearchResults] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            setSpinnerText("Retrieving Packages");
            const [data, error] = await viewAllChangeIdeaPackages(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    let mappedPackageList = data.changeIdeaPackageVOS.map((changeIdeaPackageVO) => {
                        return {...changeIdeaPackageVO}
                    });
                    setSearchResults(mappedPackageList);
                } else {
                    if (data.responseMessage !== "There was an error when trying to view the change idea Package(s). No change Idea Packages found in the database") {
                        showToaster(data);
                    }
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const handleRowClick = async (changePackage) => {
        let savedChangePackage;
        const [data, error] = await viewChangePackage(context.username, changePackage.externalReference);
        if (data) {
            if (data.responseStatus === "Success") {
                savedChangePackage = data.changeIdeaPackageVOS[0];
            } else {
                showToaster(data);
            }
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
        }
        setContext((prevState) => ({
            ...prevState,
            selectedChangePackage: savedChangePackage,
            addChangeIdeasToPackage: true,
            captureNewPackage: false,
            addClick: false,
        }));
        navigateTo("changePackageView");
    }

    return (
        <div className="problem-search-results-container">
            <div className="problem-search-results-table-container">
                {searchResults &&
                <SelectableTable tableData={searchResults}
                                 hiddenColumns={["externalReference", "isDeleted", "created", "lastModified"]}
                                 onRowClick={handleRowClick}
                                 searchEnabled={true}
                />}
            </div>
        </div>
    );
}
